import { render, staticRenderFns } from "./RecordWakewords.vue?vue&type=template&id=cee6a2f4&scoped=true&"
import script from "./RecordWakewords.vue?vue&type=script&lang=ts&"
export * from "./RecordWakewords.vue?vue&type=script&lang=ts&"
import style0 from "./RecordWakewords.vue?vue&type=style&index=0&id=cee6a2f4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee6a2f4",
  null
  
)

export default component.exports